<template>
  <div class="hl_settings--body">
    <AppReviewComponent id="marketplace-review-table-embed" v-if="$route.name=='marketplace-apps-review'" />
    <AppReviewComponent id="marketplace-review-app-embed" v-else-if="$route.name=='marketplace-app-new'" />
  </div>
</template>

<script>
export default {
  components: {
    AppReviewComponent: () => import("./AppReviewComponent.vue"),
  },
};
</script>
